import React, { createContext, useContext, useState, useCallback } from "react";
import translations from "./i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("sm_lang") || "en"; } catch { return "en"; }
  });

  const toggleLang = useCallback(() => {
    setLang((prev) => {
      const next = prev === "en" ? "ru" : "en";
      try { localStorage.setItem("sm_lang", next); } catch {}
      return next;
    });
  }, []);

  // t("nav.home") → translations[lang].nav.home
  const t = useCallback((key) => {
    const parts = key.split(".");
    let val = translations[lang];
    for (const p of parts) {
      if (val == null) return key;
      val = val[p];
    }
    return val ?? key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};

export default LanguageContext;
